module.exports = __webpack_public_path__ + "static/img/card-image-5.677b3fc1.jpg";